export const analyticsId = {
  CANCEL_LINK: 'CANCEL_LINK',
  CLICK_REQUEST_NEW_OTP_CODE: 'CLICK_REQUEST_NEW_OTP_CODE',
  CLICK_RETRY_BUTTON: 'CLICK_RETRY_BUTTON',
  CONTINUE_BUTTON: 'CONTINUE_BUTTON',
  DOWNLOAD_DOCUMENT: 'DOWNLOAD_DOCUMENT',
  KEY_PRESS_OTP: 'KEY_PRESS_OTP',
  PRINT_DOCUMENT: 'PRINT_DOCUMENT',
  RETRY_BUTTON_DOCUMENT_VIEWER: 'RETRY_BUTTON_DOCUMENT_VIEWER',
  SUCCESS_SIGN_CONTRACT: 'SUCCESS_SIGN_CONTRACT',
  TERMS_ERROR_VIEW: 'TERMS_ERROR_VIEW',
  TERMS_VIEW: 'TERMS_VIEW',
  TOGGLE_COMMERCIAL_COMMS: 'TOGGLE_COMMERCIAL_COMMS',
  TOGGLE_CONTRANCT: 'TOGGLE_CONTRANCT',
  TOGGLE_DATA_PROTECTION: 'TOGGLE_DATA_PROTECTION',
};

export const catalogue = {
  [analyticsId.CANCEL_LINK]: () => ({
    categoriaEvento: 'interaccion en migracion',
    accionEvento: 'paso_1',
    etiquetaEvento: 'cancelar',
    action: 'cancel',
    format: 'link',
    component: 'lowerNavigation',
    element: 'cancel',
  }),
  [analyticsId.CONTINUE_BUTTON]: optionalConsentChecked => ({
    categoriaEvento: 'interaccion en migracion',
    accionEvento: 'paso_1',
    etiquetaEvento: 'continuar',
    action: 'continue',
    format: 'button',
    component: 'lowerNavigation',
    element: 'continue',
    data: [
      'acceptContractualInformation/checkbox/checked',
      'readDataProtectionInformation/checkbox/checked',
      `informPaymentPartnersChangeIBAN/checkBox/${optionalConsentChecked ? 'checked' : 'uncheked'}`,
    ],
  }),
  [analyticsId.TERMS_VIEW]: () => ({
    event_name: 'step_sign_contract',
    pageName: '/migration/step01/signContract',
    sectionFamily: 'banking',
    sectionCategory: 'services',
    sectionName: 'customer',
    interactionType: 'funnel',
    serviceType: 'userSettings',
    processType: 'migration',
    processStep: 'step01',
    processDetail: 'signContract',
    nombrePagina: 'proc-migracion/paso_1/firma de contrato',
    tipoProceso: 'proc-migracion',
    pasoProceso: 'paso_1',
    detalleProceso: 'firma de contrato',
    tipoPagina: 'generica',
  }),
  [analyticsId.TERMS_ERROR_VIEW]: error => ({
    event_name: 'step_contract_error',
    pageName: '/migration/error/serviceError',
    sectionFamily: 'banking',
    sectionCategory: 'services',
    sectionName: 'customer',
    interactionType: 'funnel',
    serviceType: 'userSettings',
    processType: 'migration',
    processStep: 'error',
    processDetail: 'serviceError',
    categoryError: 'serviceError',
    errorDescription: error,
    nombrePagina: 'proc-migracion/error/servicio',
    tipoProceso: 'proc-migracion',
    pasoProceso: 'error',
    detalleProceso: 'servicio',
    tipoPagina: 'generica',
  }),
  [analyticsId.TOGGLE_CONTRANCT]: checked => ({
    categoriaEvento: 'interaccion en migracion',
    accionEvento: 'paso_1',
    etiquetaEvento: 'aceptar informacion contractual',
    action: checked ? 'check' : 'uncheck',
    format: 'checkBox',
    component: 'document',
    element: 'acceptContractualInformation',
  }),
  [analyticsId.TOGGLE_DATA_PROTECTION]: checked => ({
    categoriaEvento: 'interaccion en migracion',
    accionEvento: 'paso_1',
    etiquetaEvento: 'aceptar proteccion de datos',
    action: checked ? 'check' : 'uncheck',
    format: 'checkBox',
    component: 'document',
    element: 'dataProtection',
  }),
  [analyticsId.TOGGLE_COMMERCIAL_COMMS]: checked => ({
    categoriaEvento: 'interaccion en migracion',
    accionEvento: 'paso_1',
    etiquetaEvento: 'comunicaciones comerciales',
    action: checked ? 'check' : 'uncheck',
    format: 'checkBox',
    component: 'document',
    element: 'marketingCommunications',
  }),

  [analyticsId.CLICK_RETRY_BUTTON]: () => ({
    categoriaEvento: 'interaccion en migracion',
    accionEvento: 'error contrato',
    etiquetaEvento: 'reintentar',
    action: 'retry',
    format: 'button',
    component: 'document',
    element: 'tryAgain',
  }),
  [analyticsId.CLICK_REQUEST_NEW_OTP_CODE]: () => ({
    action: 'request',
    format: 'link',
    component: 'OTP/SMS',
    element: 'requestNewCode',
    categoriaEvento: 'interaccion en migracion',
    accionEvento: 'paso_1',
    etiquetaEvento: 'solicitar nuevo codigo',
  }),
  [analyticsId.KEY_PRESS_OTP]: () => ({
    action: 'type',
    format: 'textBox',
    component: 'OTP/SMS',
    element: 'verificationCode',
    categoriaEvento: 'interaccion en migracion',
    accionEvento: 'paso_1',
    etiquetaEvento: 'OTP code',
  }),
  [analyticsId.RETRY_BUTTON_DOCUMENT_VIEWER]: () => ({
    categoriaEvento: 'interaccion en migracion',
    accionEvento: 'error contrato',
    etiquetaEvento: 'reintentar',
    action: 'retry',
    format: 'button',
    component: 'document',
    element: 'tryAgain',
  }),
  [analyticsId.SUCCESS_SIGN_CONTRACT]: () => ({
    event_name: 'event_success',
    categoriaEvento: '/migration/step01/signContract',
    accionEvento: 'success',
    etiquetaEvento: 'backend',
    action: 'success',
    format: 'steps',
    component: 'funnel',
    element: 'signContract',
  }),
  [analyticsId.DOWNLOAD_DOCUMENT]: () => ({
    categoriaEvento: 'interaccion en migracion',
    accionEvento: 'paso_1',
    etiquetaEvento: 'descarga de contrato',
    action: 'download',
    format: 'button',
    component: 'document',
    element: 'download',
  }),
  [analyticsId.PRINT_DOCUMENT]: () => ({
    categoriaEvento: 'interaccion en migracion',
    accionEvento: 'paso_1',
    etiquetaEvento: 'imprimir contrato',
    action: 'print',
    format: 'button',
    component: 'document',
    element: 'print',
  }),
};
